class PasswordFormElementController {
  constructor() {
    this.name = 'passwordFormElement';
  }
}

export default PasswordFormElementController;
